export enum LayoutType {
  leader = 'leader',
  tile = 'tile',
  share = 'share',
}
